function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["headers"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { antNotification } from '../index';
import { request as _request, getErrMap } from '@core/shared';
import { useSharedGlobalState } from '@core/rc-state';
import { auth } from '../../Thing';
/**
 * 请求方法
 * @param url
 * @param options
 * @returns
 */
export function request(url, options) {
  var systemId = useSharedGlobalState.getState().systemId || sessionStorage.getItem('systemId');
  var _ref = options || {},
    headers = _ref.headers,
    restOptions = _objectWithoutProperties(_ref, _excluded);
  return new Promise(function (resolve, reject) {
    _request(url, _objectSpread(_objectSpread({}, restOptions), {}, {
      headers: _objectSpread({
        'system-id': systemId
      }, headers)
    })).then(function (res) {
      resolve(res);
    }).catch(function (err) {
      var _ref2 = err || {},
        code = _ref2.code,
        data = _ref2.data,
        message = _ref2.message;
      if (code === 503 && (data === null || data === void 0 ? void 0 : data.path)) {
        window.location.href = data.path;
        return;
      }
      var map = getErrMap(message);
      var errObj = map[code];
      if (errObj) {
        antNotification(errObj.type, errObj.message);
      }
      if (code === 401) {
        auth.logout();
      }
      reject(err);
    });
  });
}
// request.interceptors.request.use((url: string, options) => {
//   const fpVal = localStorage.getItem('fp');
//   const headers: HeadersInit = {};
//   // if (fpVal) {
//   //   headers.fp = fpVal;
//   //   headers.ct = '1';
//   // }
//   headers.fp = fpVal;
//   headers.pt = sessionStorage.getItem('pt') || '1';
//   headers.ct = sessionStorage.getItem('ct') || '1';
//   const systemId = useSharedGlobalState.getState().systemId || sessionStorage.getItem('systemId');
//   if (systemId) {
//     headers['system-id'] = systemId;
//   }
//   if (sessionStorage.getItem('ACCESS_TOKEN')) {
//     headers.Authorization = `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`;
//   }
//   const { headers: pHeaders, ...restOptions } = options;
//   return {
//     url,
//     options: {
//       redirect: 'follow',
//       ...restOptions,
//       headers: { ...headers, ...pHeaders },
//     },
//   };
// });
// request.interceptors.response.use(
//   async (response: Response, options) => {
//     return new Promise(async (resolve, reject) => {
//       if (response.status >= 200 && response.status < 400) {
//         const responseHeaders = options?.responseHeaders ?? [];
//         if (options.responseType === 'blob') {
//           resolve(response);
//           return;
//         }
//         const res: any = await response.clone().json();
//         const { code, message, data: result } = res;
//         if (code === 503 && result?.path) {
//           window.location.href = result.path;
//           return;
//         }
//         if (code === 500) {
//           if (message && message !== 'error.' && message !== '') {
//             antNotification('error', message);
//           } else {
//             antNotification('error', '服务器内部错误');
//           }
//         } else if (code === 550) {
//           antNotification('error', message);
//         } else if (code === 403) {
//           antNotification('error', '没有权限，请联系管理员授权');
//         } else if (code === 401) {
//           antNotification('warning', '用户认证失败，请重新登陆');
//           auth.logout();
//         }
//         const access_token = response.headers.get('access_token');
//         if (access_token) {
//           const data = JSON.parse(decodeURIComponent(access_token));
//           sessionStorage.setItem('ACCESS_TOKEN', data.access_token);
//           sessionStorage.setItem('USER_INFO', JSON.stringify(data.user_info));
//           sessionStorage.setItem('USER_NAME', data.user_info.name);
//           sessionStorage.setItem('EXPIRES_IN', data.expires_in);
//           sessionStorage.setItem('REFRESH_TOKEN', data.refresh_token);
//           sessionStorage.setItem('sessionId', data.refresh_token);
//           localStorage.setItem(
//             'storeSessionData',
//             JSON.stringify({
//               userInfo: data.user_info,
//               token: data.access_token,
//             }),
//           );
//         }
//         if (responseHeaders?.length) {
//           const getHeaders = responseHeaders.reduce((hs: any, key: any) => {
//             return { ...hs, [key]: response.headers.get(key) };
//           }, {});
//           resolve({
//             ...res,
//             responseHeaders: getHeaders,
//           });
//           return;
//         }
//         resolve(res);
//       } else {
//         const { status } = response;
//         const res: any = response.clone().json();
//         switch (status) {
//           case 500:
//             antNotification('error', '服务器内部错误');
//             break;
//           case 502:
//             antNotification('error', '服务器无响应');
//             break;
//           case 404:
//             antNotification('error', '未找到远程服务器');
//             break;
//           case 401:
//             antNotification('warning', '用户认证失败，请重新登陆');
//             break;
//           case 403:
//             antNotification('warning', '没有权限，请联系管理员授权');
//             break;
//           default:
//             antNotification('error', res.message);
//         }
//         reject(res);
//       }
//     });
//   },
//   { global: false },
// );